import React, { Component } from "react";

import NestedTabs from "../NestedTabs";
import ContainerTabProduct from "../ContainerTabProduct";
import TitleLogo from "../../Components/TitleLogo";

import "./tabs_products.css";

class ContainerTabsProducts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			childrenTab: 1,
			activeOption: 1,
			childrenOption: 1,
			dropIsOpen: false
		};
		this.onClick = this.onClick.bind(this);
		this.onClickChildren = this.onClickChildren.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeChildren = this.onChangeChildren.bind(this);
	}

	componentDidMount() {
		const _id =
			this.props && this.props.activeTab !== undefined
				? Number(this.props.activeTab)
				: this.state.activeTab;
		this.setState({
			activeTab: _id,
			childrenTab: 1,
			activeOption: _id,
			childrenOption: 1
		});
	}

	onClick(event) {
		let id = event.currentTarget.getAttribute("data-id");
		id = parseInt(id, 0);
		this.setState({
			activeTab: id,
			childrenTab: 1,
			activeOption: id,
			childrenOption: 1
		});
	}

	onClickChildren(event) {
		let id = event.currentTarget.getAttribute("data-id");
		id = parseInt(id, 0);
		this.setState({
			childrenTab: id,
			childrenOption: id
		});
	}

	onChange(event) {
		let id = event.currentTarget.value;
		id = parseInt(id, 0);
		this.setState({
			activeTab: id,
			childrenTab: 1,
			activeOption: id,
			childrenOption: 1
		});
	}

	onChangeChildren(event) {
		let id = event.currentTarget.value;
		id = parseInt(id, 0);
		this.setState({
			childrenTab: id,
			childrenOption: id
		});
	}

	render() {
		const { select_placeholder, select_product_placeholder } = this.props;
		const {
			activeTab,
			childrenTab,
			childrenOption,
			activeOption
		} = this.state;
		const _activeTab =
			isNaN(activeTab) === true || activeTab === 0 ? 1 : activeTab;
		const _childrenTab =
			isNaN(childrenTab) === true || childrenTab === 0 ? 1 : childrenTab;

		return (
			<div>
				<TitleLogo title={this.props.title} />
				<NestedTabs
					tabs={this.props.categories}
					activeTab={_activeTab}
					onClick={this.onClick}
					mobileSelect={true}
					mobileSelectPlaceholder={false}
					placeholder_cat={select_placeholder}
					onChangeSelect={this.onChange}
					activeOption={activeOption}
				>
					<NestedTabs
						tabs={this.props.categories[_activeTab - 1].products}
						activeTab={_childrenTab}
						onClick={this.onClickChildren}
						mobileSelect={true}
						mobileSelectPlaceholder={false}
						placeholder_cat={select_product_placeholder}
						activeOption={childrenOption}
						onChangeSelect={this.onChangeChildren}
					>
						<ContainerTabProduct
							{...this.props.categories[_activeTab - 1].products[
								_childrenTab - 1
							]}
						/>
					</NestedTabs>
				</NestedTabs>
			</div>
		);
	}
}

export default ContainerTabsProducts;



// WEBPACK FOOTER //
// ./src/Containers/ContainerTabsProducts/index.js